<template>
  <div class="container py-4" style="max-width: 600px;">
    <div class="d-flex align-items-center mb-4">
      <button class="btn btn-link text-dark p-0 me-3" @click="$router.go(-1)">
        <i class="bi bi-arrow-left fs-4"></i>
      </button>
      <h5 class="m-0 fw-bold">Billing History</h5>
    </div>

    <b-overlay :show="loading">
      <div v-if="listData.length === 0" class="text-center py-5">
        <i class="ri-file-list-line fs-1 text-muted mb-3"></i>
        <h6 class="text-muted">No billing history found</h6>
      </div>
      <div v-else>
        <div v-for="(item, index) in listData" :key="index" class="card border-0 shadow-sm mb-4 position-relative overflow-hidden"
          style="border-radius: 15px; background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);">

          <!-- Status indicator -->
          <div class="position-absolute top-0 end-0 p-2">
            <!-- <span class="badge" :class="getStatusClass(item.status)">
              {{ item.status || 'Paid' }}
            </span> -->
            <p class="mb-1 fw-semibold"><span :class="`badge bg-${item.active ? 'success' : 'danger'}`">{{ item.active ? 'Active': 'Inactive' }}</span></p>
          </div>

          <div class="card-body p-4">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="d-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                     style="width: 50px; height: 50px; font-size: 20px;">
                  <i class="ri-receipt-line"></i>
                </div>
              </div>
              <div class="col">
                <h6 class="card-title mb-1 fw-bold">{{ item?.subcription_plan?.plan_title || 'Subscription Plan' }}</h6>
                <p class="card-text mb-1">
                  <i class="ri-calendar-line me-1"></i> Plan Duration: {{ item?.subcription_plan?.plan_duration }}
                </p>
                <p class="card-text mb-1">
                  <i class="ri-calendar-line me-1"></i> Payment Date: {{ dDate(item.payment_date) }}
                </p>
                <p class="card-text mb-0">
                 Plan Price {{ item?.subcription_plan?.plan_price || item?.subcription_plan?.amount }}
                </p>
              </div>
              <!-- <div class="col-auto text-end">
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary rounded-pill" type="button" data-bs-toggle="dropdown">
                    <i class="ri-more-2-line"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#" @click.prevent="viewDetails(item)">View Details</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="downloadReceipt(item)">Download Receipt</a></li>
                  </ul>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
// import RestApi, { baseURL, apiBaseURL } from '@/config'
import RestApi, { baseURL, apiBaseURL } from '@/config'

export default {
  data () {
    return {
      baseURL,
      listData: [],
      loading: false,
      token: this.$route.query.token || ''
    }
  },
  created () {
    console.log('Token:', this.token)
    if (!localStorage.getItem('access_token')) {
      const token = this.$route.query.token || ''
      if (token) {
        // this.form.token = token
        localStorage.setItem('access_token', token)
        localStorage.setItem('api_token', token)
        this.$store.dispatch('Auth/setAccessToken', token)
      }
    }
    this.loadData(this.token)
  },
  methods: {
    async loadData (token) {
      this.loading = true
      try {
        // Assuming API endpoint for billing history; adjust as needed
        var { data } = await RestApi.getData(apiBaseURL, 'admin/ajax/get_user_billing_history')
        console.log('Billing History:', data)
        this.listData = data.list || []
      } catch (error) {
        console.error('Error:', error)
        this.listData = []
      } finally {
        this.loading = false
      }
    },
    getStatusClass (status) {
      const statusClasses = {
        Paid: 'bg-success',
        Pending: 'bg-warning',
        Failed: 'bg-danger',
        Refunded: 'bg-info'
      }
      return statusClasses[status] || 'bg-secondary'
    },
    viewDetails (item) {
      // Implement view details logic, e.g., show modal or navigate
      console.log('View details for:', item)
      // You can add a modal or navigate to a details page
    },
    downloadReceipt (item) {
      // Implement download receipt logic
      console.log('Download receipt for:', item)
      // You can trigger a download or open in new tab
    }
  }
}
</script>

<style scoped>
.btn-transparent {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.btn-transparent:hover {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.btn-transparent:focus {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.btn-transparent:active {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.btn-light-transparent {
  background-color: rgba(255, 255, 255, 0.262);
  border: none;
  box-shadow: none;
}
.btn-light-transparent:hover {
  background-color: rgba(255, 255, 255, 0.425);
  border: none;
  box-shadow: none;
}
.btn-outline-light {
  border-color: rgba(255, 255, 255, 0.7);
}
.btn-outline-light:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 1);
}
</style>
